import React from "react";
import { observer } from "mobx-react";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { OfferStore } from "@state/context/offer/OfferContext";
import { EventContentTab } from "@features/offer/shared/event";

export const BetBoosterSubHeaderButton = observer(
	function BetBoosterSubHeaderButton(props: {
		subHeaderType: {
			abrv: "bet-builder" | "betting-tips";
			name: string;
		};
	}) {
		const { subHeaderType } = props;
		const isBetBuilder = subHeaderType.abrv === "bet-builder";
		const isBettingTips = subHeaderType.abrv === "betting-tips";

		const store = useOfferContext<OfferStore.EventViewStore>();

		return (
			<EventContentTab
				textContent={subHeaderType.name}
				isActive={store.activeSubGroup === subHeaderType.abrv}
				onClick={() => {
					store.setActiveSubGroup(subHeaderType.abrv);
				}}
				hasBBIcon={isBetBuilder}
				hasBTIcon={isBettingTips}
			/>
		);
	}
);
